export default __webpack_public_path__ + "static/media/switch1.72c91869.svg";